(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react/jsx-runtime"), require("react"), require("video.js"), require("react-dom/client"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define(["react/jsx-runtime", "react", "video.js", "react-dom/client", "react-dom"], factory);
	else if(typeof exports === 'object')
		exports["main"] = factory(require("react/jsx-runtime"), require("react"), require("video.js"), require("react-dom/client"), require("react-dom"));
	else
		root["main"] = factory(root["react/jsx-runtime"], root["react"], root["video.js"], root["react-dom/client"], root["react-dom"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__5272__, __WEBPACK_EXTERNAL_MODULE__9155__, __WEBPACK_EXTERNAL_MODULE__8324__, __WEBPACK_EXTERNAL_MODULE__2236__, __WEBPACK_EXTERNAL_MODULE__9514__) => {
return 